import { render, staticRenderFns } from "./selectbit.vue?vue&type=template&id=6a4d3f02&"
import script from "./selectbit.vue?vue&type=script&lang=js&"
export * from "./selectbit.vue?vue&type=script&lang=js&"
import style0 from "./selectbit.vue?vue&type=style&index=0&id=6a4d3f02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports